module.exports = __webpack_public_path__ + "static/media/right.f55f0a23.jpg";